import React from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { Link } from "react-router-dom";

const faqs = [
  {
    q: "Is it really free?",
    a: "Yes. Membership is free and always will be — that's written into our nonprofit mission. We may offer optional paid services for businesses that need extra hands-on work, but the core help, resources, and tools are free for every member.",
  },
  {
    q: "What's the catch?",
    a: "There isn't one. ZelTechnology is a nonprofit built to help people who are priced out of tech support. We're funded by donations and our team's commitment to service — not by charging the people who need help most.",
  },
  {
    q: "Who are you?",
    a: "A San Diego-based nonprofit founded and staffed by people who believe in service — including individuals who have served our country. You can read our full story on the About page.",
  },
  {
    q: "What kind of tech problems can you help with?",
    a: "Slow computers, virus and scam cleanup, email setup, printer headaches, Wi-Fi troubleshooting, phone help, security checkups, and general 'I don't know what's wrong with this thing' questions.",
  },
  {
    q: "What is LAMNA?",
    a: "LAMNA is our AI assistant platform — named after the lamna shark, which never stops swimming. It's under active development; members get first access as new agents come online.",
  },
  {
    q: "Is my information safe?",
    a: "We collect the minimum we need (a username, email, and password) and nothing more. Conversations with LAMNA are never saved. We never sell, rent, or share your data — see our Privacy Policy for the full promise.",
  },
  {
    q: "Do you fix computers in person?",
    a: "We primarily provide remote guidance, education, and resources. In-person help may be available in the San Diego / North County area — contact us and ask.",
  },
  {
    q: "How can I help ZelTechnology?",
    a: "Spread the word! Tell someone who's struggling with tech. If you have IT skills and share the mission, we'd love to hear from you via the contact page.",
  },
];

const Faq = () => {
  useDocTitle("ZelT | FAQ");

  return (
    <div>
      <NavBar />
      <div className="mt-8 w-full bg-white py-12 lg:py-20">
        <div className="mx-4 max-w-3xl mx-auto">
          <h1
            className="text-4xl font-extrabold text-blue-900 text-center mb-4"
            data-aos="zoom-in"
          >
            Frequently Asked Questions
          </h1>
          <p className="text-gray-600 text-center mb-10" data-aos="fade-up">
            Honest answers, no fine print.
          </p>

          <div className="space-y-4" data-aos="fade-up">
            {faqs.map((f, i) => (
              <details
                key={i}
                className="group bg-gray-50 rounded-xl border border-gray-200 open:shadow-lg open:bg-white transition-all"
              >
                <summary className="flex justify-between items-center cursor-pointer font-bold text-blue-900 px-5 py-4 list-none">
                  {f.q}
                  <span className="text-teal-500 group-open:rotate-45 transition-transform text-xl">
                    +
                  </span>
                </summary>
                <p className="px-5 pb-5 text-gray-600 leading-relaxed">{f.a}</p>
              </details>
            ))}
          </div>

          <div className="mt-10 text-center" data-aos="fade-up">
            <p className="text-gray-600 mb-4">
              Didn't find your answer? Ask us directly.
            </p>
            <Link
              to="/contact"
              className="inline-block px-6 py-3 rounded-xl bg-blue-900 text-white font-bold hover:bg-blue-800 transition"
            >
              Contact Us
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Faq;
